import { CButton, CCard, CCardBody, CDropdownItem } from '@coreui/react-pro'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CardDiagnosisProcedure from 'src/components/common/CardDiagnosisProcedure/CardDiagnosisProcedure'
import { setDiagnosisCode, setProcedureCode } from 'src/redux/progressNote/progressNoteSlice'
import { saveBillingNotes } from 'src/helper/backendHelper'
import AdditionalInfo from './AdditionalInfo'
import ProgressNoteActionButtons from './ProgressNoteActionButtons'
import { addCPTVerification } from '../../../components/common/shared/sharedCPTLogic'
import FEATURES from '../../../utils/featuresConstants'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'
import AdditionalAttachments from '../../../components/NewEncounter/AdditionalAttachmentEncounter/AdditionalAttachments'
import { VISIT_STATUS } from '../../../utils/statusConstants'

const SherpaAI = ({
  visit,
  onBillingSave,
  setBillingTxt,
  allFacilites,
  billingTxt,
  selectedSharedProvider,
  setSelectedSharedProvider,
  incidentToProviderSubstantive,
  setIncidentToProviderSubstantive,
  isTeleHealth,
  setIsTeleHealth,
  isCareCoordination,
  setIsCareCoordination,
  isNeuroSuite,
  setIsNeuroSuite,
  isPendingCosign,
  setIsPendingCosign,
  authNumber,
  setAuthNumber,
  selectedPlaceOfService,
  onSignAndBill,
  isValidToSign,
  careTeam,
  setCareTeam,
  isHospiceRelated,
  setIsHospiceRelated,
}) => {
  const visitDetails = useSelector((state) => state?.progressNote?.visitDetails)
  const procedureCodesSelected = useSelector((state) => state?.progressNote?.procedureCodesSelected)
  const diagnosisCodesSelected = useSelector((state) => state?.progressNote?.diagnosisCodesSelected)
  const aiPredictions = useSelector((state) => state?.progressNote?.aiPredictions)
  const aiPredictionsLoading = useSelector((state) => state?.progressNote?.aiPredictionsLoading)

  const provider = useSelector((state) => state?.user?.provider)
  const features = useSelector((state) => state?.user?.features)
  const dispatch = useDispatch()

  const onBillingSign = () => {
    saveBillingNotes(visit?._id, { billing_notes: billingTxt })

    if (onSignAndBill) {
      onSignAndBill()
    }
  }

  const setSelectedDiagnosis = (data) => {
    dispatch(setDiagnosisCode(data))
  }
  const setSelectedProcedure = (data) => {
    dispatch(setProcedureCode(data))
  }

  const handleAddProcedure = (item) => {
    addCPTVerification(procedureCodesSelected, item, setSelectedProcedure)
  }

  const handleAddDiagnosis = (item) => {
    if (
      diagnosisCodesSelected.findIndex(
        (diagnosis) => diagnosis?.code === item?.code?.replace('.', ''),
      ) === -1
    ) {
      setSelectedDiagnosis([
        ...diagnosisCodesSelected,
        { ...item, code: item?.code?.replace('.', '') },
      ])
    }
  }

  const addAllDiagnosis = (itemList) => {
    let newList = []

    for (let index = 0; index < itemList.length; index++) {
      if (
        diagnosisCodesSelected.findIndex(
          (diagnosis) => diagnosis.code === itemList[index].code?.replace('.', ''),
        ) === -1
      ) {
        newList.push({ ...itemList[index], code: itemList[index].code?.replace('.', '') })
      }
    }
    setSelectedDiagnosis([...diagnosisCodesSelected, ...newList])
  }

  return (
    <>
      <CCard className="mt-3 template-container">
        <CCardBody>
          {getIsAi() && features?.includes(FEATURES.DesktopAI) ? (
            <div className="filter-holder">
              <h3>AI Charge Capture</h3>
              <p style={{ fontSize: '12px' }}>
                Claimocity coding AI is suggesting the following procedure codes and diagnosis codes
                based on the progress note
              </p>
              {aiPredictionsLoading && (
                <i className="fa-duotone fa-solid fa-spinner-third fa-spin"></i>
              )}
              <div
                className={`ai-predicts ${
                  visit?.status !== VISIT_STATUS.bill_submitted ? '' : 'disabled'
                }`}
              >
                {aiPredictions?.ICD10PCS && (
                  <div className="procedure-holder">
                    <div className="ProcedureCard">
                      <div className="ProceduredHeaderContainer">
                        <div className="ProcedureCardHeader">
                          <h5 className="card-title ProcedureCardTitle">Procedure Codes</h5>
                        </div>
                      </div>
                      <div className="Procedure-card-select-card">
                        <div className="proc-card-scroll mb-2">
                          <CardDiagnosisProcedure
                            item={aiPredictions.ICD10PCS}
                            icon={'plus'}
                            toggleFavorite={true}
                            selectedList={procedureCodesSelected}
                            handleAddRemove={handleAddProcedure}
                            type={'PROCEDURE'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {aiPredictions?.ICD10CM?.length > 0 && (
                  <div className="diagnosis-holder">
                    <div className="ProcedureCard">
                      <div className="ProceduredHeaderContainer">
                        <div className="ProcedureCardHeader">
                          <h5 className="card-title ProcedureCardTitle">Diagnosis Codes</h5>
                        </div>
                      </div>
                      <div className="Procedure-card-select-card mb-2">
                        <div className="proc-card-scroll">
                          {aiPredictions?.ICD10CM?.map((diagnosisdata, index) => (
                            <CardDiagnosisProcedure
                              key={index}
                              item={diagnosisdata}
                              icon={'plus'}
                              toggleFavorite={true}
                              selectedList={diagnosisCodesSelected}
                              handleAddRemove={handleAddDiagnosis}
                              type={'DIAGNOSIS'}
                            />
                          ))}
                        </div>

                        <center>
                          <CButton
                            color="primary"
                            onClick={() => addAllDiagnosis(aiPredictions?.ICD10CM)}
                          >
                            Add all to bill
                          </CButton>
                        </center>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="filter-holder">
              <div className="aditional-holder">
                <AdditionalAttachments
                  patientId={visitDetails?.patient_id}
                  chargeId={visitDetails?._id}
                  title={'Attachments'}
                />
                <AdditionalInfo
                  allFacilites={allFacilites}
                  visit={visit}
                  setBillingTxt={setBillingTxt}
                  billingTxt={billingTxt}
                  selectedSharedProvider={selectedSharedProvider}
                  setSelectedSharedProvider={setSelectedSharedProvider}
                  incidentToProviderSubstantive={incidentToProviderSubstantive}
                  setIncidentToProviderSubstantive={setIncidentToProviderSubstantive}
                  isTeleHealth={isTeleHealth}
                  setIsTeleHealth={setIsTeleHealth}
                  isHospiceRelated={isHospiceRelated}
                  setIsHospiceRelated={setIsHospiceRelated}
                  isCareCoordination={isCareCoordination}
                  setIsCareCoordination={setIsCareCoordination}
                  selectedPlaceOfService={selectedPlaceOfService}
                  inRight={true}
                  billingEntityOptions={[]}
                  careTeam={careTeam}
                  setCareTeam={setCareTeam}
                  isNeuroSuite={isNeuroSuite}
                  setIsNeuroSuite={setIsNeuroSuite}
                  isPendingCosign={isPendingCosign}
                  setIsPendingCosign={setIsPendingCosign}
                  authNumber={authNumber}
                  setAuthNumber={setAuthNumber}
                />
                <div className="action-sherpa">
                  <div>
                    <ProgressNoteActionButtons
                      SignButton={() => (
                        <CButton
                          className="progress-note-billing-summary-dropdown-main"
                          color="primary"
                          onClick={onBillingSign}
                          disabled={!isValidToSign}
                        >
                          {provider?.medical_coding ? 'Sign Note' : 'Sign and bill'}
                        </CButton>
                      )}
                      SaveButton={() => (
                        <CDropdownItem
                          className="progress-note-billing-summary-item progress-note-billing-summary-item-draft"
                          onClick={() => {
                            onBillingSave()
                          }}
                        >
                          <div className="progress-note-billing-summary-item-text">
                            Save as draft
                          </div>
                        </CDropdownItem>
                      )}
                      PendingReviewButton={() => (
                        <CDropdownItem className="progress-note-billing-summary-item progress-note-billing-summary-item-pending-review">
                          <div
                            className="progress-note-billing-summary-item-text"
                            onClick={() => {
                              onBillingSave(true)
                            }}
                          >
                            Pending review
                          </div>
                        </CDropdownItem>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </CCardBody>
      </CCard>
    </>
  )
}

export default SherpaAI
